import GeneralLoader from "../components/GeneralLoader";
import NotAuthenticated from "../components/NotAuthenticated";

import { connectedRouterRedirect } from "redux-auth-wrapper/history4/redirect";
import connectedAuthWrapper from "redux-auth-wrapper/connectedAuthWrapper";
import locationHelperBuilder from "redux-auth-wrapper/history4/locationHelper";
const locationHelper = locationHelperBuilder({});

// ===================================================================================
//  ADMIN
// ===================================================================================
export const adminIsAuthenticated = connectedRouterRedirect({
	// The url to redirect user to if they fail
	redirectPath: "/admin/login",

	// Determine if the user is authenticated or not
	authenticatedSelector: state => {
		// console.log("authenticatedSelector:", state.user.loginChecked.admin && state.user.admin !== null);
		return state.user.loginChecked.admin && state.user.admin !== null;
	},

	// Component to display while state is being persisted
	AuthenticatingComponent: GeneralLoader,

	// State persistance check (will take a second or so while redux-persist rehydrates)
	authenticatingSelector: state => {
		// console.log('authenticatingSelector:', state.user.loginChecked.admin)
		return !state.user.loginChecked.admin;
	},

	// A nice display name for this check
	wrapperDisplayName: "adminIsAuthenticated"
});

export const adminIsNotAuthenticated = connectedRouterRedirect({
	// This sends the user either to the query param route if we have one, or to the landing page if none is specified and the user is already logged in
	redirectPath: (state, ownProps) => {
		return locationHelper.getRedirectQueryParam(ownProps) &&
			locationHelper.getRedirectQueryParam(ownProps) !== "/admin/logout"
			? locationHelper.getRedirectQueryParam(ownProps)
			: "/admin";
	},

	// This prevents us from adding the query parameter when we send the user away from the login page
	allowRedirectBack: false,

	// Determine if the user is authenticated or not
	authenticatedSelector: state => {
		// console.log(state.user, state.user !== null)
		// console.log('adminIsNotAuthenticated:', state.user === null)
		return state.user.admin === null;
	},

	// A nice display name for this check
	wrapperDisplayName: "adminIsNotAuthenticated"
});

export const adminIsAuthenticatedNoLogin = connectedAuthWrapper({
	FailureComponent: NotAuthenticated,
	AuthenticatingComponent: GeneralLoader,
	authenticatedSelector: state => {
		// console.log(state.user.admin)
		return state.user.loginChecked.admin && state.user.admin !== null;
	},
	authenticatingSelector: state => {
		return !state.user.loginChecked.admin;
	},
	wrapperDisplayName: "adminIsAuthenticatedNoLogin"
});

// ===================================================================================
//  REVIEWER
// ===================================================================================
export const reviewerIsAuthenticated = connectedRouterRedirect({
	redirectPath: "/reviewer/login",
	authenticatedSelector: state => {
		// console.log("reviewerIsAuthenticated:", state.user.reviewer !== null);
		return state.user.reviewer !== null;
	},
	allowRedirectBack: false,
	AuthenticatingComponent: GeneralLoader,
	authenticatingSelector: state => {
		// console.log("reviewerIsAuthenticated authenticatingSelector:", !state.persist);
		return !state.persist;
	},
	wrapperDisplayName: "reviewerIsAuthenticated"
});

export const reviewerIsNotAuthenticated = connectedRouterRedirect({
	redirectPath: (state, ownProps) => {
		return locationHelper.getRedirectQueryParam(ownProps) &&
			locationHelper.getRedirectQueryParam(ownProps) !== "/reviewer/logout"
			? locationHelper.getRedirectQueryParam(ownProps)
			: "/reviewer";
	},
	allowRedirectBack: false,
	authenticatedSelector: state => {
		// console.log('reviewerIsNotAuthenticated:', state.user.reviewer === null)
		return state.user.reviewer === null;
	},
	wrapperDisplayName: "reviewerIsNotAuthenticated"
});

export const reviewerHasLoggedIn = connectedRouterRedirect({
	redirectPath: "/reviewer",
	authenticatedSelector: state => {
		// console.log("reviewerHasLoggedIn:", state.user.reviewer !== null && state.user.reviewer.user.has_logged_in);
		return !!(state.user.reviewer !== null && state.user.reviewer.user.has_logged_in);
	},
	allowRedirectBack: false,
	AuthenticatingComponent: GeneralLoader,
	authenticatingSelector: state => {
		return !state.persist;
	},
	wrapperDisplayName: "reviewerHasLoggedIn"
});

// ===================================================================================
//  REVIEWER OR ADMIN
// ===================================================================================
export const reviewerOrAdminIsAuthenticated = connectedRouterRedirect({
	redirectPath: "/reviewer/login",
	authenticatedSelector: state => {
		// console.log(state.user.reviewer !== null, state.user.loginChecked.admin && state.user.admin !== null);
		return (
			state.user.reviewer !== null ||
			(state.user.loginChecked.admin && state.user.admin !== null)
		);
	},
	AuthenticatingComponent: GeneralLoader,
	authenticatingSelector: state => {
		return !state.persist || !state.user.loginChecked.admin;
	},
	wrapperDisplayName: "reviewerOrAdminIsAuthenticated"
});

export const reviewerOrAdminIsNotAuthenticated = connectedRouterRedirect({
	redirectPath: (state, ownProps) => {
		return locationHelper.getRedirectQueryParam(ownProps) &&
			locationHelper.getRedirectQueryParam(ownProps) !== "/reviewer/logout"
			? locationHelper.getRedirectQueryParam(ownProps)
			: "/reviewer";
	},
	allowRedirectBack: false,
	authenticatedSelector: state => {
		// console.log('reviewerIsNotAuthenticated:', state.user.reviewer === null)
		return state.user.reviewer === null && state.user.admin === null;
	},
	wrapperDisplayName: "reviewerOrAdminIsNotAuthenticated"
});



// WEBPACK FOOTER //
// ./src/shared/auth.js